import { z } from 'zod';

/**
 * Where stock physically is.
 *
 * Repackaging plus two delivery models means stock lives in four places, not one. Phases 1–2
 * only move things between tienda and bodega, but the vocabulary is fixed now so a truck load
 * in phase 4 is new behaviour rather than a migration of every historical movement.
 */
export const UBICACIONES_FIJAS = ['tienda', 'bodega', 'transformacion'] as const;
export type UbicacionFija = (typeof UBICACIONES_FIJAS)[number];

export const UBICACION_LABELS: Record<UbicacionFija, string> = {
  tienda: 'Tienda',
  bodega: 'Bodega',
  transformacion: 'En reempaque',
};

export const ubicacionSchema = z
  .string()
  .regex(
    /^(tienda|bodega|transformacion|camion:[0-9a-fA-F-]{36})$/,
    'Ubicación inválida',
  );

export function esCamion(ubicacion: string): boolean {
  return ubicacion.startsWith('camion:');
}

/** The stock location for a vehicle. One spelling, used everywhere, so ids never drift. */
export function ubicacionCamion(camionId: string): string {
  return `camion:${camionId}`;
}

/** The vehicle id inside a truck location, or null if it is not one. */
export function idDeCamion(ubicacion: string): string | null {
  return esCamion(ubicacion) ? ubicacion.slice('camion:'.length) : null;
}

export function etiquetaUbicacion(ubicacion: string): string {
  if (esCamion(ubicacion)) return 'Camión';
  return UBICACION_LABELS[ubicacion as UbicacionFija] ?? ubicacion;
}
